<template>
<!-- ..  id="radialMenu"-->
  <div id="radialMenu">
    
    <radial-menu 
      style="margin: auto; margin-top: 100px; background-color: lightblue;background: transparent;"
      :itemSize="44"
      :radius="80"
      :angle-restriction="180">
        <radial-menu-item 
          
          v-for="(item, index) in items" 
          :key="index" 
          style="background-color: transparent" 
          @click="() => handleClick(item)">
          <span>{{item}}</span>
        </radial-menu-item>
      </radial-menu>
      <!-- <div style="color: rgba(0,0,0,0.6); margin-top: 16px;">{{ lastClicked }}</div> -->
  </div>
  
</template>
 
<script>
import { RadialMenu,  RadialMenuItem } from 'vue-radial-menu'
 
export default {
  name: 'radial',
  components: {
    RadialMenu,
    RadialMenuItem
  },
  data () {
    return {
      items: ['foo', 'bar', 'hello', 'world', 'more', 'items'],
      lastClicked: 'click on something!'
    }
  },
  methods: {
    handleClick (item) {
      this.lastClicked = item;
    }
  }
}
</script>